module.exports = __webpack_public_path__ + "img/费用配置.4b23f988.svg";